function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { theme, typography } from '@arc/frontend/ui-theme';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "1ab24og",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:20rem"
  } : {
    name: "bdg8r3-container",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:20rem;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  icon: /*#__PURE__*/css({
    width: '100%',
    height: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '2rem',
    maxWidth: '6.5rem',
    maxHeight: '6.5rem',
    color: theme.colors.text.hint
  }, process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  message: /*#__PURE__*/css(typography.emptyLarge, "text-align:center;max-width:40rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:message;"))
};
export function SimpleEmptySection(props) {
  return <div css={styles.container}>
			<props.Icon css={styles.icon} />
			<div css={styles.message}>{props.message}</div>
		</div>;
}